import * as actions from './actions';

const initialState = {
    // Data
    quizzes: [],
    currentQuiz: null,
    questions: [],
    currentAttempt: null,
    userAttempts: [],
    attemptDetails: null,
    categories: [],

    // UI State
    currentQuestionIndex: 0,
    selectedAnswers: {}, // { questionId: optionId }

    // Loading states
    loading: false,
    loadingQuizzes: false,
    loadingQuestions: false,
    loadingAttempt: false,
    submittingAnswer: false,
    completingQuiz: false,

    // Error states
    error: null,
    quizError: null,
    attemptError: null,
};

export default function quizReducer(state = initialState, action) {
    switch (action.type) {
        // Fetch quizzes
        case actions.FETCH_QUIZZES.REQUEST:
            return { ...state, loadingQuizzes: true, error: null };
        case actions.FETCH_QUIZZES.SUCCESS:
            return {
                ...state,
                quizzes: action.payload,
                loadingQuizzes: false
            };
        case actions.FETCH_QUIZZES.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loadingQuizzes: false
            };

        // Fetch single quiz
        case actions.FETCH_QUIZ.REQUEST:
            return { ...state, loading: true, quizError: null };
        case actions.FETCH_QUIZ.SUCCESS:
            return {
                ...state,
                currentQuiz: action.payload,
                loading: false
            };
        case actions.FETCH_QUIZ.FAILURE:
            return {
                ...state,
                quizError: action.payload.error,
                loading: false
            };

        // Fetch quiz questions
        case actions.FETCH_QUIZ_QUESTIONS.REQUEST:
            return { ...state, loadingQuestions: true, error: null };
        case actions.FETCH_QUIZ_QUESTIONS.SUCCESS:
            return {
                ...state,
                questions: action.payload,
                loadingQuestions: false,
                currentQuestionIndex: 0,
                selectedAnswers: {}
            };
        case actions.FETCH_QUIZ_QUESTIONS.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loadingQuestions: false
            };

        // Start quiz attempt
        case actions.START_QUIZ_ATTEMPT.REQUEST:
            return { ...state, loadingAttempt: true, attemptError: null };
        case actions.START_QUIZ_ATTEMPT.SUCCESS:
            return {
                ...state,
                currentAttempt: action.payload,
                questions: action.payload.questions || [],
                currentQuestionIndex: 0,
                selectedAnswers: {},
                loadingAttempt: false
            };
        case actions.START_QUIZ_ATTEMPT.FAILURE:
            return {
                ...state,
                attemptError: action.payload.error,
                loadingAttempt: false
            };

        // Submit answer
        case actions.SUBMIT_ANSWER.REQUEST:
            return { ...state, submittingAnswer: true };
        case actions.SUBMIT_ANSWER.SUCCESS:
            return {
                ...state,
                submittingAnswer: false,
                // Update the current attempt with the response
                currentAttempt: {
                    ...state.currentAttempt,
                    responses: [
                        ...(state.currentAttempt?.responses || []),
                        action.payload
                    ]
                }
            };
        case actions.SUBMIT_ANSWER.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                submittingAnswer: false
            };

        // Complete quiz attempt
        case actions.COMPLETE_QUIZ_ATTEMPT.REQUEST:
            return { ...state, completingQuiz: true };
        case actions.COMPLETE_QUIZ_ATTEMPT.SUCCESS:
            return {
                ...state,
                currentAttempt: {
                    ...state.currentAttempt,
                    ...action.payload,
                    completed: true
                },
                completingQuiz: false
            };
        case actions.COMPLETE_QUIZ_ATTEMPT.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                completingQuiz: false
            };

        // Fetch user attempts
        case actions.FETCH_USER_ATTEMPTS.REQUEST:
            return { ...state, loading: true };
        case actions.FETCH_USER_ATTEMPTS.SUCCESS:
            return {
                ...state,
                userAttempts: action.payload,
                loading: false
            };
        case actions.FETCH_USER_ATTEMPTS.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };

        // Fetch attempt details
        case actions.FETCH_ATTEMPT_DETAILS.REQUEST:
            return { ...state, loading: true };
        case actions.FETCH_ATTEMPT_DETAILS.SUCCESS:
            return {
                ...state,
                attemptDetails: action.payload,
                loading: false
            };
        case actions.FETCH_ATTEMPT_DETAILS.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };

        // Fetch categories
        case actions.FETCH_CATEGORIES.REQUEST:
            return { ...state, loading: true };
        case actions.FETCH_CATEGORIES.SUCCESS:
            return {
                ...state,
                categories: action.payload,
                loading: false
            };
        case actions.FETCH_CATEGORIES.FAILURE:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };

        // Local actions
        case actions.SET_CURRENT_QUESTION:
            return {
                ...state,
                currentQuestionIndex: action.payload.questionIndex
            };

        case actions.SET_SELECTED_OPTION:
            return {
                ...state,
                selectedAnswers: {
                    ...state.selectedAnswers,
                    [action.payload.questionId]: action.payload.optionId
                }
            };

        case actions.RESET_QUIZ_STATE:
            return {
                ...initialState,
                quizzes: state.quizzes, // Keep quizzes list
                categories: state.categories // Keep categories
            };

        default:
            return state;
    }
}
